<template>
  <footer aria-label="Site footer">
    <div class="p-8 bg-body-primary">
      <div class="xs:flex justify-between items-center">
        <ul class="xs:flex space-x-4 font-sans text-nav text-fg-g-primary text-xs list-none">
          <li><router-link :to="{ name: 'legal' }">Legal</router-link></li>
          <li v-if="isLoggedIn"><a href="/accounts/logout">Log Out</a></li>
          <li v-else><a href="/venue/login">Venue Login</a></li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import { useUserStore } from '@/stores/user'

export default defineComponent({
  name: 'FooterComponent',
  computed: {
    ...mapState(useUserStore, ['isLoggedIn']),
  },
})
</script>
